import { autoinject } from "aurelia-framework";
import { bindable } from 'aurelia-templating';
import { DetailFieldsModel } from "../../../models/common.models";

@autoinject
export class CompDetailCard {

    @bindable
    public icon: string;

    @bindable
    public title: string;
    
    @bindable
    public fields: DetailFieldsModel[];

    //used to know if the card is a tooltip
    @bindable
    public isTooltip: boolean = false;

    constructor() {}
}